import { FunctionalComponent, h } from 'preact';
import { WithStyles } from '../../../style';
import { BookingState, connectStore } from '../../../store';
import { Profile } from '../../../interfaces';
import Notification, { Severity } from '../Notification/Notification';
import { formatPoints } from '../../../i18n/Format/pointsFormatUtils';
import { Properties } from '../../../common';
import { Row } from '../../../common/Layout/Layout';
import Icon from '../../../common/Icon/Icon';
import { FinText } from '../../../i18n';

export interface PointsNotificationProps extends Properties {
  open: boolean;
}

interface PointsNotificationStoreProps {
  profile: Profile;
}

const mapStateToProps = ({ profile }: BookingState): PointsNotificationStoreProps => ({
  profile,
});

type PointsNotificationRenderProps = PointsNotificationProps & PointsNotificationStoreProps & WithStyles;

export const PointsNotification: FunctionalComponent<PointsNotificationProps> = connectStore({
  mapStateToProps,
})(({ open, profile }: PointsNotificationRenderProps) => {
  return (
    <Notification
      data-test-points-notification
      class="nordic-blue-50-bg mr-clear-t"
      open={open}
      severity={Severity.INFO}
      award
    >
      {open && (
        <Row hCenter vCenter class="pr-medium-x rounded-medium open">
          <div class="ps-small-r">
            <Icon iconName="info-block" class="ir-small" />
          </div>
          <FinText id="award.notifications.totalPoints" fields={{ points: formatPoints(profile.awardPoints) }} />
        </Row>
      )}
    </Notification>
  );
});
